/**
* @name APP parvulo
* @description
* # name controller --> indicatorsCreateController
* # As Controller --> indicatorsCreate
* brief comment controller creation levels users
*/

export default class indicatorsCreateController {
  	constructor($scope,learningObjetivesServices,indicatorsServices,ngNotify,UserInfoConstant,$state,$filter) {
		this.$scope = $scope
		this.ngNotify = ngNotify
		this.$state = $state
		this.services = indicatorsServices.services
		this.learningObjetivesServices   = learningObjetivesServices.services
		this.$scope.grid = false
		this.$translate = $filter('translate');
        this.conceptId = 0
		this.$scope.learningObjetiveSelect = null
		this.name = null
		this.code = null
		this.learningObjectiveId = null
		
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});
   	}

	init(){
		const params = {
			concept_id : this.conceptId ? this.conceptId : false
		}
		this.getLearningObjectives(params)
	}

	getLearningObjectives(params){
		this.learningObjetivesServices.getLearningObjetives(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.learningObjetivesList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	beforeSave(){
		if(this.name === null) {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.code === null) {
			this.ngNotify.set('Indique código','warn')
			return
		}

		if(this.learningObjectiveId === null) {
			this.ngNotify.set('Seleccione un Obejtivo de Aprendizaje','warn')
			return
		}		

		this.$scope.isDisabled = true;
		let params  = { 
			name   : this.name,
			code   : this.code,
			user_id : this.user_id,
			concept_id: this.conceptId,
			learning_objective_id: this.learningObjectiveId
		}

		this.save(params)
	}

	selectChanged(learningObjetiveSelect){
		this.learningObjectiveId = learningObjetiveSelect

	}

	save(params){
		this.services.saveIndicators(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha creado el Indicador correctamente','success');
				this.$state.go("app.indicators");
			}else{
				this.ngNotify.set('Error con servicio check request','error');
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de indicador ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})
	}
}
indicatorsCreateController.$inject=['$scope', 'learningObjetivesServices', 'indicatorsServices', 'ngNotify','UserInfoConstant','$state','$filter']








// WEBPACK FOOTER //
// ./src/app/admin-panel/indicators/create/indicatorsCreateController.js